import React, { Component } from 'react'
import { Col, Row, Panel , PanelGroup } from "react-bootstrap";
import {   reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import {  fetchActiveSeasons } from "../../redux/actions/action_seasonsettings"
import ContentWrapper from "../../components/layout/ContentWrapper";
import Ranking from './Components/Ranking'
import SeasonDates from './Components/SeasonDates'
import OilConditions from './Components/OilConditions'
import Setup from './Components/Setup'
import Participant from './Components/Participant'
import Template from './Components/Template'

const formName = 'seasonsettings'
const SettingsTabs = {
    Dates:1,
    OilConditions:2,
    Setup:3,
    Participants:4,
    Template:5,
    RankingPoints:6
}

// this is a HOC that host all other components that make up the process of setting up a season 
class SeasonSettings extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props,context) {
        super(props,context)
        this.state = {
            activeKey:-1,
            datesopen:false,
            oilopen:false,
            setupopen:false,
            participantopen:false,
            templateopen:false,
            datesSaved:true,
            oilSaved:true,
            setupSaved:true,
            participantSaved:true,
            templateSaved:true,
            resetDates:false,
            resetOil:false,
            resetSetup:false,
            resetParticipant:false,
            resetTemplate:false,
        }
        this.handleSelectedSeasonChanged = this.handleSelectedSeasonChanged.bind(this)
        this.handlePanelNavigation       = this.handlePanelNavigation.bind(this)
        this.checkSettingsSaved          = this.checkSettingsSaved.bind(this)
        this.settingsDataSaved           = this.settingsDataSaved.bind(this)
        this.datesResetDone              = this.datesResetDone.bind(this)
        this.oilResetDone                = this.oilResetDone.bind(this)
        this.setupResetDone              = this.setupResetDone.bind(this)
        this.participantResetDone        = this.participantResetDone.bind(this)
        this.templateResetDone           = this.templateResetDone.bind(this)
    }
    componentDidMount(){
        this.props.fetchActiveSeasons()
    }
    handleSelectedSeasonChanged(seasonId,seasonyears){
        const { dispatch } = this.props
        // update the settingsseason value
        dispatch(change(formName, 'settingsseason',seasonId))
        dispatch(change('seasonoil', 'settingsseason',seasonId))
        dispatch(change('seasonsetup', 'settingsseason',seasonId))
        dispatch(change('seasonparticipants', 'settingsseason',seasonId))
        dispatch(change('seasontemplate', 'settingsseason',seasonId))
        dispatch(change('seasonranking', 'settingsseason',seasonId))
        dispatch(change(formName, 'seasonyears',seasonyears))
    }
    handlePanelNavigation(activeKey) {       
        this.setState({ activeKey })   
        switch(activeKey){
            case SettingsTabs.Dates:{
                this.setState({ datesopen: !this.state.datesopen })
                break
            }
            case SettingsTabs.OilConditions:{
                this.setState({ oilopen: !this.state.oilopen })
                break
            }
            case SettingsTabs.Setup:{
                this.setState({ setupopen: !this.state.setupopen })
                break
            }
            case SettingsTabs.Participants:{
                this.setState({ participantopen: !this.state.participantopen })
                break
            }  
            case SettingsTabs.Template:{
                this.setState({ templateopen: !this.state.templateopen })
                break
            }  
        }
      
        this.checkSettingsSaved()
    }
    checkSettingsSaved() {       
        const { activeKey, datesopen,oilopen,setupopen,participantopen,templateopen,
                datesSaved,oilSaved,setupSaved,participantSaved,templateSaved } = this.state
        const collapsed = true 
           
        switch(activeKey) {
            case SettingsTabs.Dates:{
                if(datesopen == collapsed){
                    if(datesSaved == false){
                        this.setState({ resetDates:true })
                    }
                }    
                if (oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if(setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if (participantSaved == false){
                    this.setState({ resetParticipant:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }
                break
            }
            case SettingsTabs.OilConditions:{
                if(oilopen == collapsed){
                  if(oilSaved == false){
                    this.setState({ resetOil:true })
                  }
                }
                if (datesSaved == false){
                    this.setState({ resetDates:true })
                }
                if(setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if (participantSaved == false){
                    this.setState({ resetParticipant:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }            
                break
            }
            case SettingsTabs.Setup:{
                //console.log('checkSettingsSaved setupopen,setupSaved',setupopen,setupSaved) 
                if(setupopen == collapsed){
                    if(setupSaved == false){
                        this.setState({ resetSetup:true })
                    }
                }
                if (datesSaved == false){
                    this.setState({ resetDates:true })
                }
                if(oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if (participantSaved == false){
                    this.setState({ resetParticipant:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }
                break
            }
            case SettingsTabs.Participants:{
                if(participantopen == collapsed){
                    if(participantSaved == false){
                        this.setState({ resetParticipant:true })
                    }
                }
                if (datesSaved == false){
                    this.setState({ resetDates:true })
                }
                if(oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if (setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }
                break
            } 
            case SettingsTabs.Template:{
                if(templateopen == collapsed){
                    if(templateSaved == false){
                        this.setState({ resetTemplate:true })
                    }
                }
                if (datesSaved == false){
                    this.setState({ resetDates:true })
                }
                if(oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if (setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if(participantSaved ==  false){
                    this.setState({ resetParticipant:true })
                }
                break
            }  
            case SettingsTabs.RankingPoints:{
               console.log('SettingsTabs.RankingPoints datesSaved',datesSaved)
                if (datesSaved == false){
                    this.setState({ resetDates:true })
                }
                if(oilSaved == false){
                    this.setState({ resetOil:true })
                }
                if (setupSaved == false){
                    this.setState({ resetSetup:true })
                }
                if(participantSaved ==  false){
                    this.setState({ resetParticipant:true })
                }
                if(templateSaved ==  false){
                    this.setState({ resetTemplate:true })
                }
                break
            }                                 
        }
    }
    settingsDataSaved(dataSaved, settingTab) { 
        switch(settingTab) {
            case SettingsTabs.Dates:{
                this.setState({ datesSaved:dataSaved })
                break
            }
            case SettingsTabs.OilConditions:{
                this.setState({ oilSaved:dataSaved })
                break
            }
            case SettingsTabs.Setup:{
                this.setState({ setupSaved:dataSaved })
                break
            }
            case SettingsTabs.Participants:{
                this.setState({ participantSaved:dataSaved })
                break
            }
            case SettingsTabs.Template:{
                this.setState({ templateSaved:dataSaved })
                break
            }
        }
    }

    // Reset the reset flags if a reset was done
    datesResetDone(){
        this.setState({ resetDates:false })
    }
    oilResetDone(){
        this.setState({ resetOil:false })
    }
    setupResetDone(){
        this.setState({ resetSetup:false })
    }
    participantResetDone(){
        this.setState({ resetParticipant:false })
    }
    templateResetDone(){
        this.setState({ resetTemplate:false })
    }

    render() {
        const { seasonyears } = this.props
        const { resetDates,resetOil, resetSetup,resetParticipant,resetTemplate } = this.state

        return (
            <ContentWrapper>
                <div className="content-heading">Season Settings</div>
                <h5>Manage settings and default values used during event creation</h5>
                <hr/>
                    <Row className="center-block center-text">
                        <Col lg={12}>
                            <PanelGroup accordion id="seasonsettings">
                                <Panel eventKey={SettingsTabs.Dates}
                                    title = "Initiate a season by setting the season dates"
                                    header = "Season Dates"
                                    collapsible 
                                    expanded={this.state.datesopen}
                                    onSelect={this.handlePanelNavigation}
                                >
                                    <SeasonDates onSeasonChange={this.handleSelectedSeasonChanged} settingsSaved={this.settingsDataSaved} resetform={resetDates}  resetDone={this.datesResetDone} />
                                </Panel>
                                <Panel eventKey={SettingsTabs.OilConditions}
                                    title = "Classify the governing Lanes oil ratios"
                                    header = "Lane Oil Conditions"
                                    collapsible
                                    expanded={this.state.oilopen}
                                    onSelect={this.handlePanelNavigation}
                                    >
                                        <OilConditions  seasonyears={seasonyears}  settingsSaved={this.settingsDataSaved} resetform={resetOil} resetDone={this.oilResetDone} />
                                </Panel>   
                        
                                <Panel eventKey={SettingsTabs.Setup}
                                    title = "Identify minimum number of game and maximum day requirements"
                                    header = "Setup"
                                    collapsible 
                                    expanded={this.state.setupopen}
                                    onSelect={this.handlePanelNavigation}
                                >
                                    <Setup  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetSetup} resetDone={this.setupResetDone}   />
                                </Panel>        
                                <Panel eventKey={SettingsTabs.Participants}
                                    header = "Participants"
                                    collapsible
                                    expanded={this.state.participantopen}
                                    onSelect={this.handlePanelNavigation}
                                >
                                    <Participant  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetParticipant}  resetDone={this.participantResetDone}/>
                                </Panel>
                                <Panel eventKey={SettingsTabs.Template}
                                    title = "Establish the template download period"
                                    header = "Event Template"
                                    collapsible
                                    onSelect={this.handlePanelNavigation}
                                >
                                    <Template  seasonyears={seasonyears} settingsSaved={this.settingsDataSaved} resetform={resetTemplate} resetDone={this.templateResetDone}/>
                                </Panel> 
                                <Panel eventKey="6"
                                    title = "Establish how ranking points are assigned"
                                    header = "Ranking Table"
                                    collapsible
                                    onSelect={this.handlePanelNavigation}
                                >         
                                    <Ranking />          
                                </Panel>
                            </PanelGroup>
                        </Col>
                    </Row>              
            </ContentWrapper>)
    }
}
SeasonSettings.propTypes = {
    dispatch:PropTypes.func,
    fetchActiveSeasons: PropTypes.func,
    seasonyears:PropTypes.string,
    settingsseason:PropTypes.number  
}
function mapStateToProps(state,ownProps){
    const formName =  ownProps.form
    const selector = formValueSelector(formName)
    const seasonyears = selector(state,'seasonyears')
    const settingsseason = selector(state,'settingsseason') 
    return {
        seasonyears, 
        settingsseason
    }
}
function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchActiveSeasons,
    },dispatch)
}
export default reduxForm({
  form:formName,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(SeasonSettings))




// WEBPACK FOOTER //
// ./src/containers/season/SeasonSettings.js